import { OnSchedRest }  from "../OnSchedRest";
import { OnSchedUtils } from "../utils";

export const GetPaymentIntent = (element) => new Promise(resolve => {
  const { params, options, onsched } = element;

  let data = {
    currency: options.payments?.currency ? options.payments?.currency : "usd",
    amount: options.payments?.amount ? options.payments?.amount : 5000, // Amount is represented in cents (5000 = $50.00)
    locationId: params.locationId ? params.locationId : '',
    testKeys: options.payments?.testKeys ? options.payments?.testKeys : true, // TRUE in Sandbox Environment, FALSE in Production Environment
    connectedAccount: options.payments?.connectedAccount ? options.payments?.connectedAccount : false, // TRUE will allow for a connected account configuration within Stripe
  };
  
  const url = onsched.apiBaseUrl.replace('/consumer', '/payment') + '/stripepayments/paymentintents';
  
  OnSchedRest.Post(url, data, response => {
    if (response.error) {
      OnSchedUtils.Toast(element, response);
    }
    
    resolve(response);
  });
})